// extracted by mini-css-extract-plugin
module.exports = {"card__members":"FilledCardMembers_card__members__3tuWz","members":"FilledCardMembers_members__2VOzM","members__avatar":"FilledCardMembers_members__avatar__1cQJK"};